import { DefaultOptionType } from "antd/es/select";
import { ColumnsType } from "antd/es/table";
import { t } from "i18next";
import { ColorText } from "../../../components/ColorText/ColorText";
import {
  formatDateFilterApi,
  formatDateFilterView,
} from "../../../utils/dateFormatter";
import { FilterItem, FilterItemType } from "../../filters/filters.types";
import {
  ExciseLicenceRequest,
  ExciseLicenceRequestListPayload,
} from "./exciseLicences.types";

export const EXCISE_LICENCE_INITIAL_FILTERS = {
  statusId: null,
  tipZahteva: null,
  vrstaProizvoda: null,
  brojResenja: null,
  datumVazenja: null,
  datum: null,
};

export const getExciseLicenceRequestFilterItems = ({
  statuses,
  isLoading,
  requestTypes,
  productTypes,
}: {
  isLoading?: boolean;
  productTypes?: Array<DefaultOptionType>;
  requestTypes?: Array<DefaultOptionType>;
  statuses?: Array<DefaultOptionType>;
}): Array<FilterItem<ExciseLicenceRequestListPayload>> => {
  return [
    {
      fieldName: "statusId",
      type: FilterItemType.SELECT,
      props: {
        placeholder: t("PLACEHOLDERS.STATUS"),
        loading: isLoading,
        options: statuses,
      },
    },
    {
      fieldName: "tipZahteva",
      type: FilterItemType.SELECT,
      props: {
        placeholder: t("TABLES.TIP_ZAHTEVA"),
        loading: isLoading,
        options: requestTypes,
      },
    },
    {
      fieldName: "datum",
      type: FilterItemType.DATE_RANGE,
      props: {
        placeholder: [t("PLACEHOLDERS.DATUM_OD"), t("PLACEHOLDERS.DATUM_DO")],
      },
    },
    {
      fieldName: "vrstaProizvoda",
      type: FilterItemType.SELECT,
      props: {
        placeholder: t("TABLES.VRSTA_PROIZVODA"),
        loading: isLoading,
        options: productTypes,
      },
    },
    {
      fieldName: "brojResenja",
      type: FilterItemType.TEXT,
      props: {
        placeholder: t("TABLES.BROJ_RESENJA"),
      },
    },
    {
      fieldName: "datumVazenja",
      type: FilterItemType.DATE,
      props: {
        placeholder: t("PLACEHOLDERS.DATUM_VAZENJA"),
      },
      formatForApi: formatDateFilterApi,
      formatForClient: formatDateFilterView,
    },
  ];
};

export const getExciseLicenceRequestTableColumns = () => {
  return [
    {
      title: t("TABLES.BROJ_ZAHTEVA"),
      dataIndex: "brojZahteva",
      width: "120px",
    },
    { title: t("TABLES.DATUM_KREIRANJA_ZAHTEVA"), dataIndex: "datumZahteva" },
    {
      title: t("TABLES.TIP_ZAHTEVA"),
      dataIndex: "tipZahteva",
    },
    {
      title: t("TABLES.BROJ_RESENJA"),
      dataIndex: "brojResenja",
    },
    {
      title: t("TABLES.DATUM_DO_KADA_VAZI_RESENJE"),
      dataIndex: "datumVazenja",
    },
    {
      title: t("TABLES.STATUS"),
      dataIndex: "statusZahteva",
      render: (status: string) => ColorText(status),
    },
  ] as ColumnsType<ExciseLicenceRequest>;
};

export const DUVAN_FIELDS_EXCISE_LICENCE = [
  "kolicinaDuvanaKg",
  "kolicinaPojedinacnihPakovanjaKomadi",
  "prosecnaKolicinaDuvanaKg",
  "prosecnaKolicinaPojedinacnihPakovanjaKomadi",
];
export const DUVAN_FIELDS_EXCISE_WAREHOUSE = [
  "planiranaProizvodnjaProizvodaKg",
  "planiranaProizvodnjaProizvodaKomadi",
  "kolicinaProizvodaIzPrethodneGodineKg",
  "kolicinaProizvodaIzPrethodneGodineKomadi",
];
export const OTHER_FIELDS_EXCISE_LICENCE = [
  "kolicinaUskladistenihProizvoda",
  "prosecanMesecniRashod",
];
export const OTHER_FIELDS_EXCISE_WAREHOUSE = [
  "kolicinaProizvodaIzPrethodneGodine",
  "planiranaProizvodnjaProizvoda",
];

export enum AkcizneDozvoleDokumentiTipovi {
  IzjavaDaIspunjavaElektronskuRazmenuPodataka = 1,
  OdobrenjeNadleznogOrganaZaKoriscenjeMernihUredjaja,
  DokazOVlasnistvuIliZakupu,
  PostupakStecajaIliLikvidacije,
  UpisanURegistarProizvodjaca,
  KrivicniPostupakProtivOdgovornihLica,
  DokazOPopisuAkciznihProizvoda,
}

export const MAX_UPLOAD_SIZE = 20 * 1024 * 1024;
